var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewDeclined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83341 1.3335C4.29365 1.3335 4.66675 1.70659 4.66675 2.16683V3.00017H5.50008C5.96032 3.00017 6.33342 3.37327 6.33342 3.8335C6.33342 4.29374 5.96032 4.66684 5.50008 4.66684H4.66675V5.50018C4.66675 5.96041 4.29365 6.33351 3.83341 6.33351C3.37317 6.33351 3.00008 5.96041 3.00008 5.50018V4.66684H2.16674C1.7065 4.66684 1.3334 4.29374 1.3334 3.8335C1.3334 3.37327 1.7065 3.00017 2.16674 3.00017H3.00008V2.16683C3.00008 1.70659 3.37317 1.3335 3.83341 1.3335ZM3.83341 9.66685C4.29365 9.66685 4.66675 10.04 4.66675 10.5002V11.3335H5.50008C5.96032 11.3335 6.33342 11.7066 6.33342 12.1669C6.33342 12.6271 5.96032 13.0002 5.50008 13.0002H4.66675V13.8335C4.66675 14.2938 4.29365 14.6669 3.83341 14.6669C3.37317 14.6669 3.00008 14.2938 3.00008 13.8335V13.0002H2.16674C1.7065 13.0002 1.3334 12.6271 1.3334 12.1669C1.3334 11.7066 1.7065 11.3335 2.16674 11.3335H3.00008V10.5002C3.00008 10.04 3.37317 9.66685 3.83341 9.66685Z",
    fill: "#5C6075"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66672 1.3335C10.0448 1.3335 10.3756 1.58807 10.4723 1.95359L11.455 5.66595L14.2498 7.27836C14.5078 7.42719 14.6667 7.70237 14.6667 8.00018C14.6667 8.298 14.5078 8.57318 14.2498 8.72201L11.455 10.3344L10.4723 14.0468C10.3756 14.4123 10.0448 14.6669 9.66672 14.6669C9.28861 14.6669 8.95789 14.4123 8.86113 14.0468L7.87845 10.3344L5.08364 8.722C4.82568 8.57318 4.66675 8.298 4.66675 8.00018C4.66675 7.70237 4.82568 7.42719 5.08364 7.27836L7.87845 5.66595L8.86113 1.95359C8.95789 1.58807 9.28861 1.3335 9.66672 1.3335Z",
    fill: "#5C6075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewDeclined);
export default __webpack_public_path__ + "static/media/interview-declined.9adcf225cefdad5a660b9552f09db03a.svg";
export { ForwardRef as ReactComponent };